<template>
    <Layout>
        <PageHeader title="Add Email Content" class="poppins fw-normal p-2" />
        <div class="addUser mt-3">
            <div class="row">
                <div class="col-lg-12 col-12">
                    <div class="card border-radius-12 border">
                        <div class="card-body">
                            <div v-if="processing && updateId" class="text-center py-5">
                                <APILoader :loading="processing" />
                            </div>
                            <form ref="form" @submit.prevent="submit" v-show="!(processing && updateId)">
                                <div class="row">
                                    <div class="col-md-6 col-xl-4">
                                        <div class="my-2 ">
                                            <label class="form-label fw-bold" for="formrow-Firstname-input">Email
                                                Notification Type</label>
                                            <select v-model="form.type" class="form-control rounded-pill"
                                                :disabled="updateId">
                                                <option value="">Select Type</option>
                                                <option v-for="(type, index) in types" :key="index" :value="type.value">
                                                    {{
                                                        type.text
                                                    }}</option>
                                            </select>
                                            <div class="error" v-if="$v.form.type.$error">
                                                <div class="error" v-if="$v.form.type.$error">
                                                    Type is Required!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xl-4">
                                        <div class="my-2 ">
                                            <label class="form-label fw-bold" for="subject">Subject</label>
                                            <input type="text" class="form-control  rounded-pill" id="subject"
                                                v-model="form.subject" placeholder="Enter Subject" />
                                            <div class="error" v-if="$v.form.subject.$error">
                                                <div class="error" v-if="$v.form.subject.$error">
                                                    Subject is Required!
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="my-2 ">
                                            <label class="form-label fw-bold" for="body">Body <a
                                                    href="javascript:void(0)" @click="previewEmail"
                                                    v-if="form.body">Click here to preview Email</a></label>
                                            <editor v-model="form.body" :init="editorConfig" />
                                            <div class="error" v-if="$v.form.body.$error">
                                                <div class="error" v-if="$v.form.body.$error">
                                                    Body is Required!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 my-2 " v-if="typeKeys.length">
                                        <div class="d-flex flex-column gap-1">
                                            <h5 class="mb-0"> Dynamic Keys </h5>
                                            <p class="f-14 mb-0">{{ formattedTypeKeys }}</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12 my-2 " v-if="typeKeys.length">
                                        <div class="d-flex flex-column gap-1">
                                            <h5 class="mb-0"> Notification Description </h5>
                                            <p class="f-14 mb-0" v-if="form.type">{{types.find((type) => type.value ===
                                                form.type).description}}</p>
                                        </div>
                                    </div>
                                                                <!-- <div class="col-12">
                                <div class="d-flex gap-2">
                                    <h5 v-if="form.type">Notification Description :</h5>
                                    <p class="f-14" v-if="form.type">{{types.find((type) => type.value ===
                                        form.type).description}}</p>
                                </div>
                            </div> -->
                                </div>
                                <div class="d-flex flex-column flex-md-row justify-content-md-end gap-2 gap-sm-3 w-100">
                                    <div
                                        class="cta_submit border-orange rounded-pill p1 w-100 w-md-auto">
                                        <SubmitButton :processing="processing" type="submit"
                                            class="btn btn-primary waves-effect waves-light w-100 w-md-auto"
                                            :text="updateId ? 'Update' : 'Add'" />
                                    </div>
                                    <div
                                        class="cta_submit border-dark rounded-pill p1 w-100 w-md-auto">
                                        <SubmitButton @clicked="resetForm" type="button"
                                            :color='"btn waves-effect waves-light bg-black py-2 w-100 w-md-auto"' text="Cancel" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <b-modal ref="previewModal" size="xl" hide-footer title="Email Preview">
                    <iframe v-if="previewHtml" :srcdoc="previewHtml" class="w-100 border rounded"
                        style="height:80vh;"></iframe>
                </b-modal>
            </div>
        </div>

    </Layout>
</template>
<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import APILoader from "../../../../components/general/APILoader.vue";
import { required, alpha } from "vuelidate/lib/validators";

export default {
    name: "add-email-content",
    components: {
        Layout,
        PageHeader,
        APILoader,
    },
    data() {
        return {
            processing: false,
            types: [],
            form: {
                subject: null,
                type: "",
                body: null,
                details: null,
            },
            previewHtml: null,
            editorConfig: {
                branding: false,
                promotion: false,
                tinymceScriptSrc: '/node_modules/tinymce/tinymce.min.js',
                height: 300,
                menubar: false,

                // plugins: 'autolink paste',
                plugins: 'autolink paste hr',
                toolbar: `
                    bold italic underline |
                    fontsizeselect |
                    alignleft aligncenter alignright |
                    hr |
                    removeformat
                `,
                formats: {
                    alignleft: {
                        selector: 'p,div',
                        styles: { textAlign: 'left' }
                    },
                    aligncenter: {
                        selector: 'p,div',
                        styles: { textAlign: 'center' }
                    },
                    alignright: {
                        selector: 'p,div',
                        styles: { textAlign: 'right' }
                    }
                },
                fontsize_formats: '12px 14px 16px 18px 20px',

                forced_root_block: 'p',
                force_br_newlines: false,
                force_p_newlines: true,

                valid_elements: 'p,strong,em,u,span[style],br,hr',
                valid_styles: {
                    '*': 'font-size,font-weight,font-style,text-decoration,text-align'
                },

                convert_urls: false,

                content_style: `
                    body {
                    font-family: Montserrat, Arial, sans-serif;
                    font-size: 14px;
                    line-height: 1.6;
                    color: #302F2B;
                    }

                    p {
                    margin: 0 0 12px 0;
                    }
                    hr {
                    border: none;
                    border-top: 1px solid #dddddd;
                    margin: 16px 0;
                    }
                }
            `,
            cleanup: true,
            cleanup_on_startup: true,
            verify_html: true,
            remove_trailing_brs: true,
            extended_valid_elements: 'p[style],span[style],strong,em,u,br',
            invalid_elements: 'script',
            setup(editor) {
                editor.on('GetContent', function (e) {
                e.content = e.content.replace(/ data-mce-[^=]+="[^"]*"/g, '');
                });
            }

            },



        };
    },
    validations: {
        form: {
            subject: {
                required,
            },
            type: {
                required,
            },
            body: {
                required,
            },
        },
    },
    created() {
        if (this.updateId) {
            this.getEmailById(this.updateId);
        }
    },
    mounted() {
        this.getTypes();
    },
    computed: {
        typeKeys() {
            if (!this.form.type) {
                return [];
            }
            let keys = this.types.find((type) => type.value === this.form.type)?.keys;
            return keys || [];
        },
        formattedTypeKeys() {
            return this.typeKeys.map(key => `@{${key}}`).join(' ');
        },
        updateId() {
            return this.$route.query?.emailId ?? null;
        }
    },
    methods: {
        getTypes() {
            this.$axios.get("email-content/get-types").then((response) => {
                this.types = response.data.data;
            });
        },
        resetForm() {
            this.$router.push("/email-content/listing");
        },
        previewEmail() {
            this.$axios.post("email-content/get-preview", { body: this.form.body }).then((response) => {
                this.previewHtml = response.data.html;
                this.$refs.previewModal.show();
            });
        },
        getEmailById(emailId) {
            this.processing = true;
            this.$axios.get(`email-content/show/${emailId}`).then((response) => {
                this.form = response.data.data;
                this.processing = false;
            }).catch(() => {
                this.processing = false;
            });
        },
        submit(e) {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.triggerSwal("Please fill all required fields", "error");
            } else {
                this.processing = true;
                this.form.details = this.types.find((type) => type.value === this.form.type).description;
                
                this.$axios.post("email-content/create", this.form).then((response) => {
                    this.processing = false;
                    this.triggerSwal(
                        this.updateId ? "Email Content Updated Successfully" : "Email Content Added Successfully",
                        "success"
                    );
                    this.$router.push("/email-content/listing");
                }).catch((error) => {
                    this.processing = false;
                    this.triggerSwal(error.response.data.message, "error");
                });
            }
        },
    },
};
</script>
<style scoped>
    .cta_submit{
        width : auto !important;
    }
</style>